<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-form :inline="true" :model="searchCondition">
        <el-form-item label="订单编号">
          <el-input
            v-model="searchCondition.orderId"
            placeholder="订单编号"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="商户订单编号">
          <el-input
            v-model="searchCondition.outTradeNo"
            placeholder="商户订单编号"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="付费名称">
          <el-input
            v-model="searchCondition.name"
            placeholder="付费名称"
            size="small"
          ></el-input>
        </el-form-item>
        <el-form-item label="考试名称">
          <el-select
            v-model="searchCondition.examName"
            filterable
            size="small"
            placeholder="考试名称"
          >
            <el-option
              v-for="item in billTotal.examName"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            v-model="searchCondition.examName"
            placeholder="考试名称"
            size="small"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="对账状态">
          <el-select v-model="searchCondition.status" size="small">
            <el-option label="全部" value=""></el-option>
            <el-option label="未对账" value="0"></el-option>
            <el-option label="已对账" value="1"></el-option>
            <el-option label="异常" value="2"></el-option>
            <el-option label="已冲正" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付时间">
          <el-date-picker
            size="small"
            style="width: 200px"
            v-model="searchCondition.payTime"
            type="daterange"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="
              (value) => {
                [searchCondition.payStartTime, searchCondition.payEndTime] =
                  value || ['', ''];
              }
            "
          >
          </el-date-picker></el-form-item
        ><el-form-item label="对账时间"
          ><el-date-picker
            style="width: 200px"
            size="small"
            v-model="searchCondition.billTime"
            type="daterange"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="
              (value) => {
                [searchCondition.billStartTime, searchCondition.billEndTime] =
                  value || ['', ''];
              }
            "
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="发票状态">
          <el-select v-model="searchCondition.invoiceStatus" size="small">
            <el-option label="所有" value=""></el-option>
            <el-option label="已开" value="1"></el-option>
            <el-option label="未开" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="getData"
            >查询</el-button
          >
          <el-button size="small" @click="resetSearchCondition">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="cardContainer">
      <div class="dataCard" style="background: rgba(88, 163, 247, 1)">
        <div class="cardValue">
          {{ billTotal.Sum }} <span style="font-size: 0.5em">元</span>
        </div>
        <div class="cardKey">总订单金额</div>
      </div>
      <div class="dataCard" style="background: rgba(254, 192, 61, 1)">
        <div class="cardValue">
          {{ billTotal.doneBillSum }} <span style="font-size: 0.5em">元</span>
        </div>
        <div class="cardKey">已对账金额</div>
      </div>
      <div class="dataCard" style="background: rgba(82, 193, 245, 1)">
        <div class="cardValue">
          {{ billTotal.noBillSum }} <span style="font-size: 0.5em">元</span>
        </div>
        <div class="cardKey">未对账金额</div>
      </div>
      <div class="dataCard" style="background: rgba(251, 98, 96, 1)">
        <div class="cardValue">
          {{ billTotal.errBillSum }} <span style="font-size: 0.5em">元</span>
        </div>
        <div class="cardKey">异常金额</div>
      </div>
      <div class="dataCard" style="background: rgba(129, 103, 245, 1)">
        <div class="cardValue">
          {{ billTotal.correctBillSum }}
          <span style="font-size: 0.5em">元</span>
        </div>
        <div class="cardKey">调整金额(冲正)</div>
      </div>
    </div>
    <div class="tableContainer">
      <div class="actBar">
        <el-dropdown trigger="click" class="reviewBar">
          <el-button type="primary" size="small">导入数据</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-upload
                action="/base/common/importAliPayBill"
                :show-file-list="false"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-success="importSuccess"
              >
                <el-button size="mini" type="primary">支付宝导入</el-button>
              </el-upload>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-upload
                action="/base/common/importWeXinBill"
                :headers="{ Authorization: getStore('accessToken') }"
                :show-file-list="false"
                :on-success="importSuccess"
              >
                <el-button size="mini" type="primary">微信导入</el-button>
              </el-upload>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-table
        ref="multipleTable"
        :data="billList"
        tooltip-effect="light"
        border
        @sort-change="sortChange"
        :header-cell-style="{ background: '#f8f8f9' }"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="45"> </el-table-column>

        <el-table-column prop="orderId" label="订单编号" width="120">
        </el-table-column
        ><el-table-column prop="outTradeNo" label="商户订单号" width="120">
        </el-table-column
        ><el-table-column prop="name" label="付费名称" width="120" sortable>
        </el-table-column
        ><el-table-column
          prop="examName"
          label="考试名称"
          min-width="120"
          sortable
        ></el-table-column>
        <el-table-column
          prop="orderAmount"
          label="订单金额"
          width="120"
          sortable
        >
        </el-table-column
        ><el-table-column prop="payType" label="支付方式" width="120" sortable>
        </el-table-column
        ><el-table-column prop="payDate" label="支付时间" width="160" sortable>
        </el-table-column
        ><el-table-column
          prop="updateTime"
          label="对账时间"
          width="160"
          sortable
        >
        </el-table-column
        ><el-table-column
          prop="status"
          sortable
          label="对账状态"
          width="120"
          :formatter="
            ({ status }) => ['未对账', '已对账', '异常', '已冲正'][status]
          "
        >
        </el-table-column
        ><el-table-column
          prop="isInvoice"
          sortable
          label="发票状态"
          width="120"
          :formatter="({ isInvoice }) => ['', '已开', '未开'][isInvoice]"
        >
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }"
            ><el-button size="small" type="text" @click="showDetail(row)"
              >查看详情</el-button
            ></template
          >
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="getData"
        @size-change="getData"
        :current-page.sync="searchCondition.pageNumber"
        :page-sizes="[10, 30, 100]"
        :page-size.sync="searchCondition.pageSize"
        :total="searchCondition.total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="对账单信息"
      append-to-body
      :visible.sync="billDetail.ifShow"
      top="5vh"
      width="60%"
    >
      <h3 style="margin: 10px 0"><i class="el-icon-s-flag"></i> 订单信息</h3>
      <div class="boxForm">
        <div class="boxFormCell">
          <div class="boxFormKey">订单编号</div>
          <div class="boxFormValue">{{ billDetail.orderId }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">商户订单号</div>
          <div class="boxFormValue">{{ billDetail.outTradeNo }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">付费名称</div>
          <div class="boxFormValue">{{ billDetail.name }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">考试名称</div>
          <div class="boxFormValue">{{ billDetail.examName }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">订单金额</div>
          <div class="boxFormValue">{{ billDetail.orderAmount }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">支付方式</div>
          <div class="boxFormValue">{{ billDetail.payType }}</div>
        </div>
        <div class="boxFormCell">
          <div class="boxFormKey">支付时间</div>
          <div class="boxFormValue">{{ billDetail.payDate }}</div>
        </div>
      </div>
      <h3 style="margin: 10px 0"><i class="el-icon-s-flag"></i> 对账信息</h3>
      <div class="boxForm">
        <div class="boxFormCell">
          <div class="boxFormKey">对账状态</div>
          <div class="boxFormValue">
            {{ ["未对账", "已对账", "异常", "已冲正"][billDetail.status] }}
          </div>
        </div>
        <div
          class="boxFormCell"
          v-if="billDetail.status == 1 || billDetail.status == 3"
        >
          <div class="boxFormKey">对账人员</div>
          <div class="boxFormValue">{{ billDetail.updateUser }}</div>
        </div>
        <div
          class="boxFormCell"
          v-if="billDetail.status == 1 || billDetail.status == 3"
        >
          <div class="boxFormKey">对账时间</div>
          <div class="boxFormValue">{{ billDetail.updateTime }}</div>
        </div>
        <div
          class="boxFormCell"
          v-if="billDetail.status == 2 || billDetail.status == 3"
        >
          <div class="boxFormKey">异常原因</div>
          <div class="boxFormValue">{{ billDetail.reason }}</div>
        </div>
        <div
          class="boxFormCell"
          v-if="billDetail.status == 2 || billDetail.status == 3"
        >
          <div class="boxFormKey">调整后金额</div>
          <div class="boxFormValue">
            <el-input
              size="small"
              v-model="billDetail.reviseAmount"
              v-if="billDetail.status == 2"
            ></el-input>
          </div>
          <div class="boxFormValue" v-if="billDetail.status == 3">
            {{ billDetail.reviseAmount }}
          </div>
        </div>
        <div
          class="boxFormCell"
          v-if="billDetail.status == 2 || billDetail.status == 3"
        >
          <div class="boxFormKey">处理备注</div>
          <div class="boxFormValue">
            <el-input
              size="small"
              v-model="billDetail.remark"
              v-if="billDetail.status == 2"
            ></el-input>
          </div>
          <div class="boxFormValue" v-if="billDetail.status == 3">
            {{ billDetail.remark }}
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 15px">
        <el-button type="primary" size="small" @click="toCorrect"
          >冲正处理</el-button
        >
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="createInvoiceDetail.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="batchCreateInvoice()"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { getStore, setStore } from "@/libs/storage";

import {
  getBillList,
  updateBill,
  importBillInformationByAli,
  importBillInformationByWechat,
} from "@/api/bill.js";
export default {
  data() {
    return {
      getStore: getStore,
      searchCondition: {
        sort: "",
        order: "",
        pageNumber: 1,
        pageSize: 10,
        outTradeNo: "",
        examName: "",
        payTime: "",
        payStartTime: "",
        payEndTime: "",
        billTime: "",
        billStartTime: "",
        billEndTime: "",
        orderId: "",
        name: "",
        invoiceStatus: "",
        status: "",
        outTradeNo: "",
        total: 0,
      },
      billList: [],
      billDetail: {
        ifShow: false,
      },
      billTotal: {
        Sum: 0,
        correctBillSum: 0,
        doneBillSum: 0,
        errBillSum: 0,
        noBillSum: 0,
      },
    };
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    pageInit() {
      this.getData();
    },
    resetSearchCondition() {
      Object.assign(this.searchCondition, this.$options.data().searchCondition);
      this.pageInit();
    },
    sortChange({ column, order, prop }) {
      var theOrder = null;
      switch (order) {
        case "ascending":
          theOrder = "asc";
          break;
        case "descending":
          theOrder = "asc";
          break;

        default:
          theOrder = null;
          break;
      }
      Object.assign(this.searchCondition, {
        sort: prop,
        order: theOrder,
        pageNumber: 1,
      });
      this.getData();
    },
    importSuccess(...e) {
      console.log(e);
    },
    importBill(type, e) {
      console.log(type, e.file);
      switch (type) {
        case "ali":
          importBillInformationByAli({ file: e.file }).then((data) => {
            console.log(data);
          });
          break;
        case "wechat":
          importBillInformationByWechat({ file: e.file }).then((data) => {
            console.log(data);
          });
          break;
        default:
          break;
      }
    },
    showDetail(item) {
      let showData = {};
      Object.assign(showData, item);
      showData.ifShow = true;
      this.billDetail = showData;
    },
    handleSelectionChange() {},
    getData() {
      let postData = {};
      for (let i in this.searchCondition) {
        if (this.searchCondition[i]) {
          postData[i] = this.searchCondition[i];
        }
      }
      getBillList(postData).then((data) => {
        this.billList = data.rows;
        this.searchCondition.total = data.total;
        this.billTotal = data.map;
        // console.log(data);
      });
    },
    toCorrect() {
      let postData = {};
      Object.assign(postData, this.billDetail);
      if (!this.billDetail.reviseAmount) {
        this.$message.warning("请输入冲正金额");
        return;
      }
      postData.status = 1;
      updateBill(postData).then(() => {
        this.$message.success("冲正成功");
        this.billDetail.ifShow = false;
        this.pageInit();
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    background: #fff;
    padding: 15px;
    .el-input {
      width: 200px;
    }
    .el-form--inline .el-form-item {
      margin-bottom: 0px !important;
      margin-right: 20px !important;
    }
  }
  .cardContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 0;
    .dataCard {
      height: 120px;
      width: 18%;
      border-radius: 10px;
      padding: 25px 30px 30px 30px;
      color: #fff;
      background: red;
      .cardValue {
        font-size: 28px;
      }
      .cardKey {
        // margin-top: 10px;
        font-size: 14px;
      }
    }
  }
}
.boxForm {
  .boxFormCell {
    display: flex;
    justify-content: space-between;
    border: 1px solid #ccc;
    border-bottom-width: 0;
    .boxFormKey {
      padding: 10px;
      // text-align: right;
      border-right: 1px solid #ccc;
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .boxFormValue {
      padding: 10px;
      text-align: left;
      flex: 1;
    }
  }
  .boxFormCell:last-child {
    border-bottom-width: 1px;
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
